import { saveTicket } from '../../actionCreators/tickets';
import firebase from 'firebase/app';
import 'firebase/firestore';
import { firestoreStructure } from '../../models/FirebaseStructure';
import Ticket from '../../models/Ticket';
import { ThunkDispatch } from 'redux-thunk';
import { AppState } from '../../reducers';
import { SaveTicketActionType } from '../../actions/tickets';

const postTicketThunk = (ticket: Ticket) => async (
    dispatch: ThunkDispatch<void, AppState, SaveTicketActionType>
): Promise<void> => {
    const document = firebase
        .firestore()
        .collection(firestoreStructure.Tickets.name)
        .doc(ticket.id);
    await document.set(ticket.toJS(), { merge: true });
    dispatch(saveTicket(ticket));
};

export default postTicketThunk;
